import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import ProductCategory1 from '../white-paper-bags/Product-category-section/product-category1';
import ProductCategory2 from '../white-paper-bags/Product-category-section/product-category2';
// import ProductCategory3 from '../white-paper-bags/Product-category-section/product-category3';
// import ProductCategory4 from '../white-paper-bags/Product-category-section/product-category4';
// import ProductCategory5 from '../white-paper-bags/Product-category-section/product-category5';
import ProductCategory6 from '../white-paper-bags/Product-category-section/product-category6';
const WhitePaperBags = () => {
  const navigate=useNavigate()
  return (
    <>
    <div className="container-fluid  bags-container d-flex align-items-center" >
      <div className="row justify-content-center w-100">
        <div className="col-12 col-lg-10">
        <div className="card-banner">
        <div className="row g-0">
              {/* Left side with single product image */}
              <div className="col-md-6  d-flex align-items-center justify-content-center p-5" >
                <img
                  src="/assets/products-with-logo/paper-bags/white-paper-bags.jpg"
                  className="img-fluid"
                  alt="white-paper-bag"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
              
              {/* Right side content */}
              <div className="col-md-6 d-flex align-items-center" >
                <div className="p-4 p-lg-5 w-100">
                  <small className="text-black text-uppercase letter-spacing-1 mb-2 d-block">
                  Elegant, lightweight, reusable 
                  </small>
                  
                  <h2 className="main-heading display-5 fw-bold text-dark mb-4">
                  White Paper Bags                  
                  </h2>
                  
                  <p className="product-each-desc text-black mb-4 lead">
                  {/* White paper bags are lightweight, and durable, offering a clean, versatile, and recyclable packaging solution for diverse applications.                  */}

                  White paper bags are a classic and versatile packaging solution that offers a clean, elegant look for your business. Our twisted handle bags, made from high-quality bleached kraft paper, are durable and stylish, perfect for retail stores, boutiques, and events. These professional-looking bags can safely carry up to 5 kg of distributed weight, making them strong enough for heavy items. We use water-based inks and premium adhesives to ensure the bags remain odor-free and safe for various packing applications. Through our in-house design team, the bags can be customized to your specific size and design requirements. For trials, sudden demand increases, or general market needs, we also keep unprinted bags in regular sizes readily available.
                   </p>
                  
                  <div className="text-center mb-4">
                    <button 
                      className="btn btn-dark btn-sm rounded-pill text-uppercase mx-auto" 
                      style={{ 
                        width: '100px',
                        fontSize: '0.6rem',
                        padding: '10px 2px',
                        lineHeight: '1.2',
                        display: 'block'
                      }} onClick={()=>{navigate('/contact')}}>
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProductCategory1/>
        <ProductCategory6/>

    <ProductCategory2/>

    {/* <ProductCategory3/>
     <ProductCategory4/>
    <ProductCategory5/> */}
    
</>
  );
};

export default WhitePaperBags;